import {
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  FormTextField,
  LoadingButton,
  Stack,

} from '@datanomik/commons-ui';
import { ArrowBack } from '@mui/icons-material';

import { useForm } from 'react-hook-form';

import { useTranslation } from 'react-i18next';
import { useSendSuggestion } from './useSendSuggestion';

type SuggestionFormData = {
  suggestion: string;
};

type SupportPanelSuggestionsProps = {
  onBack: () => void;
  onSuccess: () => void;
};

export function SupportPanelSuggestions({ onBack, onSuccess }: SupportPanelSuggestionsProps) {
  const { t } = useTranslation();
  const { mutateAsync, isPending } = useSendSuggestion();

  const formMethods = useForm<SuggestionFormData>({
    defaultValues: {
      suggestion: '',
    },
    mode: 'onSubmit',
  });

  const onSend = formMethods.handleSubmit(async (data) => {
    await mutateAsync(data.suggestion);
    onSuccess();
  });

  return (
    <Stack height="100%">
      <DrawerHeader
        startAdornment={(
          <ArrowBack
            onClick={onBack}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'translateX(-4px)',
              },
            }}
          />
        )}
        text={t('Suggestions & Improvements')}
      />
      <DrawerBody sx={{
        flex: 1,
      }}
      >
        <Stack spacing={2}>
          <Stack p={2}>
            <FormTextField
              required
              label={t('Describe your idea')}
              placeholder={t('Type your suggestion here...')}
              multiline
              rows={20}
              control={formMethods.control as any}
              name="suggestion"
              validationRules={{
                required: t('This field is required'),
                minLength: {
                  value: 10,
                  message: t('The suggestion must be at least 10 characters long'),
                },
              }}
              slotProps={{
                input: {
                  sx: {
                    backgroundColor: 'background.100',
                    padding: '16px',
                  },
                },
              }}
            />
          </Stack>
        </Stack>
      </DrawerBody>
      <DrawerFooter sx={{

      }}
      >
        <Button
          variant="outlined"
          color="black"
          onClick={onBack}
          fullWidth
        >
          {t('Cancel')}
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={onSend}
          fullWidth
          loading={isPending}
        >
          {t('Send')}
        </LoadingButton>
      </DrawerFooter>
    </Stack>
  );
}
